import { LINE_POSITIONS } from '../constants/animation-sequence.ts';
import { BallAnimation } from '../slices/ball/ball.slice.types.ts';
import { KeyWordPosition } from '../slices/story-reading/story-reading.slice.types.ts';
import { RenderableStoryLine } from '../types/story-reading.types.ts';

import { WordCountResult } from './story-sentence-animation-word-count.mapper.ts';

export const mapStorySentenceAnimationMultiLine = (
  startPosition: KeyWordPosition,
  finalPosition: KeyWordPosition,
  wordCounts: WordCountResult,
  msPerWord: number,
  lines: RenderableStoryLine[]
): BallAnimation[] => {
  const firstLineWords = wordCounts.lines[0];
  const firstLineAnimation = {
    fromXPosition: startPosition.startX,
    toXPosition: LINE_POSITIONS.END_X,
    duration: firstLineWords * msPerWord,
    rowIndex: startPosition.line,
  };

  const middleLines = lines.slice(startPosition.line + 1, finalPosition.line);
  const middleLinesWordCounts = wordCounts.lines.slice(1);
  const middleLineAnimations = middleLines.map((_, index) => ({
    fromXPosition: LINE_POSITIONS.START_X,
    toXPosition: LINE_POSITIONS.END_X,
    duration: middleLinesWordCounts[index] * msPerWord,
    rowIndex: startPosition.line + 1 + index,
  }));

  const lastLineWordCount = wordCounts.lines[wordCounts.lines.length - 1];
  const lastLineAnimation = {
    fromXPosition: LINE_POSITIONS.START_X,
    toXPosition: finalPosition.endX,
    duration: lastLineWordCount * msPerWord,
    rowIndex: finalPosition.line,
  };

  return [firstLineAnimation, ...middleLineAnimations, lastLineAnimation];
};
